import React, { useState } from 'react';

export default function Logo({ className = '' }) {
  const [imgError, setImgError] = useState(false);

  if (imgError) {
    return (
      <picture>
        <source
          srcSet="/images/processed/logos/logo-400x400.webp 400w, /images/processed/logos/logo-200x200.webp 200w"
          type="image/webp"
        />
        <img
          src="/images/processed/logos/logo-200x200.jpg"
          srcSet="/images/processed/logos/logo-200x200.jpg 200w, /images/processed/logos/logo-400x400.jpg 400w"
          alt="Sri GDM Interior Industries"
          className={`${className} object-contain w-14 h-14 md:w-28 md:h-28 rounded`}
          loading="eager"
        />
      </picture>
    );
  }

  return (
    <img
      src="/images/Logo.png"
      alt="Sri GDM Interior Industries"
      className={`${className} object-contain w-14 h-14 md:w-28 md:h-28`}
      loading="eager"
      onError={() => setImgError(true)}
    />
  );
}
